@if (!isSecret) {
  <p class="mt-4 mb-4">
    @if (route) {
      <span (click)="navigate()"
        ><strong>{{ label }}</strong> <a class="link">{{ value }}</a>
      </span>
    }
    @if (!route) {
      <span>
        <strong>{{ label }}</strong> <span>{{ value }}</span>
      </span>
    }
  </p>
}

@if (isSecret) {
  <p class="mt-4 mb-4">
    @if (isVisible) {
      <span>
        <strong>{{ label }}</strong> <span>{{ value }}</span>
      </span>
    }
    @if (!isVisible) {
      <span>
        <strong>{{ label }}</strong> <span>-------------------------</span>
      </span>
    }
    @if (!isVisible) {
      <button mat-icon-button (click)="isVisible = true">
        <mat-icon>visibility_off</mat-icon>
      </button>
    }
    @if (isVisible) {
      <button mat-icon-button (click)="isVisible = false">
        <mat-icon>visibility</mat-icon>
      </button>
    }
  </p>
}
